<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-data-table class="alarm-conditions-list" v-model="selected" :sort-by.sync="sortedBy" :sort-desc.sync="sortDesc" :item-class="rowSelected" :search="search" :headers="headers" :items="$props.alarmConditions" :single-select="false" item-key="condition_id" show-select checkbox-color="#FFFFFF" fixed-header @dblclick:row="(e, item) => editAlarmCondition(item.item)" :items-per-page="-1" @update:sort-by="sortBySelected" @update:sort-desc="sortBySelected">

            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title style="color: #FFFFFF; font-weight: bold;">Alarm Conditions</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field color="#c42111" class="" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-btn color="#c42111" @click="addNew" :disabled="lockSave">Add New</v-btn>
                </v-toolbar>
            </template>

            <template v-slot:item.active="{ item }">
                <div style="margin-top: -16px">
                    <v-switch v-model="item.active" hide-details color="#ffffff" @change="activeChanged(item)" :disabled="lockSave" />
                </div>
            </template>

            <template v-slot:item.actions="{ item }">
                <div style="width: 90px;">
                    <v-icon class="mr-2" @click="editAlarmCondition(item)" :disabled="lockSave">mdi-pencil</v-icon>
                    <v-icon @click="deleteAlarmConditionClick(item)" :disabled="lockSave || (item.alarm_correlations.some(ac => ac != $props.alarmCorrelationId))">mdi-delete</v-icon>
                </div>
            </template>

            <template v-slot:item.dow="{ item }">
                <span>{{dowString(item)}}</span>
            </template>

            <template v-slot:item.selected="{ item }">
                <span>{{selectedAlarmConditionIDs.includes(item.condition_id) ? "Yes" : "No"}}</span>
            </template>

            <template v-slot:footer>
                <span class="selected-count validation-massage" v-if="$props.selectedAlarmConditions.filter(c => c.active).length < 2"><v-icon color="#ff5252" class="mr-2">mdi-alert</v-icon>You must select at least <u>two active</u> alarm conditions.</span>
                <span class="selected-count" v-else>{{`${$props.selectedAlarmConditions.length} selected alarm conditions`}}</span>
            </template>

        </v-data-table>


        <v-dialog v-model="showEditAlarmCondition" max-width="80%" width="1200px" persistent v-if="showEditAlarmCondition">
            <alarm-condition :localeList="localeList" :alarmCondition="editAlarmConditionClone" @cancel="cancelEdit" @save="saveClick" />
        </v-dialog>
    </v-container>
</template>

<script>
import AlarmCondition from "@/components/AlarmCorrelations/AlarmCondition";
export default {
    name: 'AlarmConditionsList',
    props: ['localeList', 'alarmConditions', 'selectedAlarmConditions', 'lockSave', 'alarmCorrelationId'],
    components: {
        AlarmCondition
    },
    data: () => ({
        showGrid: false,
        gridOptions: null,
        alarmConditionFormValid: true,
        search: "",
        sortedBy: null,
        sortDesc: null,
        headers: [
            {text: 'Active', filterable: false, groupable: false, sortable: false,  value: 'active'},
            {text: 'Actions', filterable: false, groupable: false, sortable: false,  value: 'actions'},
            {text: 'Office', align: 'start', sortable: true, value: 'condition_office'},
            {text: 'Location', align: 'start', sortable: true, value: 'condition_location'},
            {text: 'Locale', align: 'start', sortable: true, value: 'condition_locale'},
            {text: 'Severity', align: 'start', sortable: true, value: 'condition_orig_severity'},
            {text: 'Description', align: 'start', sortable: true, value: 'condition_code'},
            {text: 'Repeats', align: 'start', sortable: true, value: 'condition_repeats'},
            {text: 'Repeats Within Min', align: 'start', sortable: true, value: 'condition_repeats_within_min'},
            {text: 'After Time', align: 'start', sortable: true, value: 'condition_after_time'},
            {text: 'Before Time', align: 'start', sortable: true, value: 'condition_before_time'},
            {text: 'DOW', align: 'start', sortable: false, value: 'dow'},
            {text: 'Selected', filterable: false, groupable: false, sortable: true, value: 'selected'},
        ],

        showEditAlarmCondition: false,
        editAlarmConditionClone: null
    }),

    computed: {
        selected: {
            get: function() {
                let val = this.$props.alarmConditions.filter(ac => {
                    return this.selectedAlarmConditionIDs.includes(ac.condition_id);
                });
                return val;
            },
            set: function(values) {
                let selectedAlarmConditions = values.map(ac => {return {condition_id: ac.condition_id, active: ac.active}});
                // Cannot set directly becuase Vue complains about directly mutating a prop.
                this.$emit('selected', selectedAlarmConditions);
            }
        },

        selectedAlarmConditionIDs() {
            return this.$props.selectedAlarmConditions.map(ac => ac.condition_id);
        }
    },

    methods: {
        activeChanged: function(item) {
            let selectedAlarmCondition = this.$props.selectedAlarmConditions.find(ac => item.condition_id == ac.condition_id);
            if(selectedAlarmCondition) {
                selectedAlarmCondition.active = item.active;
            }
        },

        rowSelected: function(item) {
            return this.selectedAlarmConditionIDs.includes(item.condition_id) ? "alarm-condition-row-selected" : "";
        },

        sortBySelected: function(val) {
            if(this.sortedBy == "selected") {
                this.$props.alarmConditions.sort((a,b) => {
                    return (this.selectedAlarmConditionIDs.includes(a.condition_id) ? 1 : -1) * (this.sortDesc ? 1 : -1);
                });
            }
        },

        dowString: function(alarmCondition) {
            let dowString = '';
            dowString += (alarmCondition.condition_days_sun ? 'Su' : '');
            dowString += (alarmCondition.condition_days_mon ? 'M' : '');
            dowString += (alarmCondition.condition_days_tue ? 'Tu' : '');
            dowString += (alarmCondition.condition_days_wed ? 'W' : '');
            dowString += (alarmCondition.condition_days_thu ? 'Th' : '');
            dowString += (alarmCondition.condition_days_fri ? 'F' : '');
            dowString += (alarmCondition.condition_days_sat ? 'Sa' : '');
            return dowString;
        },

        editAlarmCondition: function(alarmCondition) {
            if(this.$props.lockSave) {
                return;
            }
            this.editAlarmConditionClone = JSON.parse(JSON.stringify(alarmCondition));
            this.showEditAlarmCondition = true;

        },

        cancelEdit: function() {
            this.showEditAlarmCondition = false;
            this.editAlarmConditionClone = null;
        },

        saveClick: function() {
            if(this.editAlarmConditionClone.condition_id !== 0) {
                // Warn the shit out of them that this will change all instances of this alarm condition. Maybe let the user know how many 
                // alarm correlation rules are currently using this condition AND even how many current active alarms are actively satisfying this condition.
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to save this alarm condition?',
                    type: 'warning',
                    confirmAction: () => {this.save();}
                });
            }
            else {
                this.save();
            }
        },

        save: function() { 
            if(this.editAlarmConditionClone.condition_id == 0) {
                let route = (TELSA.apiHost + "alarmcorrelations/alarmcondition/add");
                TELSA.loading(true);
                return this.$http.post(route, {args: {alarm_condition: this.editAlarmConditionClone}}).then(response => {
                    let result = response.body;
                    this.editAlarmConditionClone.condition_id = result;
                    this.editAlarmConditionClone.active = true; // active by default
                    this.editAlarmConditionClone.alarm_correlations = [];
                    this.$props.alarmConditions.push(this.editAlarmConditionClone);
                    this.showEditAlarmCondition = false;
                    this.editAlarmConditionClone = null;
                    TELSA.loading(false);
                });
            }
            else {
                let route = (TELSA.apiHost + "alarmcorrelations/alarmcondition/edit");
                TELSA.loading(true);
                let alarmCondition = this.$props.alarmConditions.find(ac => ac.condition_id == this.editAlarmConditionClone.condition_id);
                for(let key of Object.keys(alarmCondition)) {
                    alarmCondition[key] = this.editAlarmConditionClone[key];
                }
                return this.$http.post(route, {args: {alarm_condition: alarmCondition}}).then(response => {
                    let result = response.body;
                    this.showEditAlarmCondition = false;
                    this.editAlarmConditionClone = null;
                    TELSA.loading(false);
                });
            }
        },

        deleteAlarmConditionClick: function(alarmCondition) {
            // Warn the shit out of them that this will change all instances of this alarm condition. Maybe let the user know how many 
            // alarm correlation rules are currently using this condition AND even how many current active alarms are actively satisfying this condition.
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: 'Are you sure you want to delete this alarm condition?',
                type: 'warning',
                confirmAction: () => {this.deleteAlarmCondition(alarmCondition);}
            });
        },

        deleteAlarmCondition: function(alarmCondition) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "alarmcorrelations/alarmcondition/delete");
            let alarmConditionId = alarmCondition.condition_id;
            return this.$http.post(route, {args: {alarm_condition_id: alarmConditionId}}).then(response => {
                let result = response.body;
                let index = this.$props.alarmConditions.findIndex(ac => ac.condition_id == alarmConditionId);
                this.$props.alarmConditions.splice(index, 1);
                TELSA.loading(false);
            });
        },

        addNew: function() {
            this.editAlarmConditionClone = {
                condition_id: 0,
                condition_office: "",
                condition_location: "",
                condition_locale: "",
                condition_orig_severity: "",
                condition_code: "",
                condition_repeats: 0,
                condition_repeats_within_min: 0,
                condition_after_time: "",
                condition_before_time: "",
                condition_days_sun: true,
                condition_days_mon: true,
                condition_days_tue: true,
                condition_days_wed: true,
                condition_days_thu: true,
                condition_days_fri: true,
                condition_days_sat: true,
            };
            this.showEditAlarmCondition = true;
        }

    },

    created() {
        this.$props.alarmConditions.forEach(ac => {ac.active = true;});
        // Now set active to false for the conditions that were selected and marked active=false
        this.$props.selectedAlarmConditions.forEach(sac => {
            if(!sac.active) {
                this.$props.alarmConditions.find(ac => ac.condition_id == sac.condition_id).active = false;
            }
        });
    },

    mounted() {
    }

  
};
</script>

<style scoped>

    .alarm-conditions-list {
        max-height: calc(100vh - 220px);
        overflow-y: auto;
    }

    .selected-count {
        position: absolute;
        margin-top: 12px;
        margin-left: 0px;
    }

    .selected-count.validation-massage {
        color: #ff5252;
    }

</style>

<style>

    .alarm-conditions-list .v-data-table__wrapper {
        max-height: calc(100vh - 370px);
        overflow-y: auto;
    }

    .alarm-condition-row-selected {
        background-color: #c42111 !important;
    }

</style>
